import * as Icons from "@phosphor-icons/react";
import { checkIsBusinessUser } from "selectors/user";
import {
  checkSelectedBusinessHasWhoAsk,
  checkSelectedBusinessRpaMode
} from "selectors/businesses";
import { getActiveOrganization } from "selectors/organizations";
import { getTextsData } from "selectors/texts";
import { useSelector } from "react-redux";
import NoDataContent from "nlib/common/NoDataContent";
import React from "react";
import Texts from "utils/Texts";
import TransactionsStatuses from "nlib/pages/TransactionsPage/TransactionsStatuses";
import useEnvVars from "hooks/useEnvVars";

const EmptyState = ({ fetchingData }) => {
  const [{ status: statusFilter }] = useEnvVars();

  const { messages, uiTexts } = useSelector(getTextsData);

  const businessUser = useSelector(checkIsBusinessUser);

  const rpaMode = useSelector(checkSelectedBusinessRpaMode);

  const selectedBusinessHasWhoAsk = useSelector(checkSelectedBusinessHasWhoAsk);

  const { businessOrganization } = useSelector(getActiveOrganization);

  const { labelLangId: statusLabelLangId } = (statusFilter && TransactionsStatuses.getStatusData([
    statusFilter,
    businessOrganization,
    rpaMode && !selectedBusinessHasWhoAsk,
    businessUser
  ])) || {};

  const statusLabel = statusLabelLangId && uiTexts[statusLabelLangId].toLowerCase();

  if (fetchingData) return null;

  return (
    <NoDataContent
      icon={!statusLabel && businessUser ? Icons.CheckCircle : Icons.CreditCard}
      title={statusLabel
        ? Texts.replaceVars(uiTexts.noStatusTransactions, { status: statusLabel })
        : (businessUser ? messages.allThingsDone : uiTexts.noTransactions)} />
  );
};

export default React.memo(EmptyState);
